import { render, staticRenderFns } from "./FormDeleteMerchant.vue?vue&type=template&id=9fb12cfe&scoped=true"
import script from "./FormDeleteMerchant.vue?vue&type=script&lang=js"
export * from "./FormDeleteMerchant.vue?vue&type=script&lang=js"
import style0 from "./FormDeleteMerchant.vue?vue&type=style&index=0&id=9fb12cfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb12cfe",
  null
  
)

export default component.exports